import AsyncStorage from '@react-native-async-storage/async-storage';

export const storeAccessToken = async (value) => {
  try {
    await AsyncStorage.setItem('token', JSON.stringify(value));
  } catch (e) {
    // saving error
  }
};

export const getAccessToken = async () => {
  try {
    let data = await AsyncStorage.getItem('token');
    return data != null ? JSON.parse(data) : null;
  } catch (e) {
    // error reading value
  }
};
export const storeSubId = async (value) => {
  try {
    await AsyncStorage.setItem('id', JSON.stringify(value));
  } catch (e) {
    // saving error
  }
};

export const getSubId = async () => {
  try {
    let data = await AsyncStorage.getItem('id');
    return data != null ? JSON.parse(data) : null;
  } catch (e) {
    // error reading value
  }
};

export const storeUserName = async (value) => {
  try {
    await AsyncStorage.setItem('name', JSON.stringify(value));
  } catch (e) {
    // saving error
  }
};

export const getUserName = async () => {
  try {
    let data = await AsyncStorage.getItem('name');
    return data != null ? JSON.parse(data) : null;
  } catch (e) {
    // error reading value
  }
};
export const storeAccountId = async (value) => {
  try {
    await AsyncStorage.setItem('accId', JSON.stringify(value));
  } catch (e) {
    // saving error
  }
};

export const getAccountId = async () => {
  try {
    let data = await AsyncStorage.getItem('accId');
    return data != null ? JSON.parse(data) : null;
  } catch (e) {
    // error reading value
  }
};

export const storeProfileInfo = async (value) => {
  try {
    await AsyncStorage.setItem('profile', JSON.stringify(value));
  } catch (e) {
    // saving error
  }
};

export const getAsyncProfileInfo = async () => {
  try {
    let data = await AsyncStorage.getItem('profile');
    return data != null ? JSON.parse(data) : null;
  } catch (e) {
    // error reading value
  }
};
export const storeBrandId = async (value) => {
  try {
    await AsyncStorage.setItem('brandId', JSON.stringify(value));
  } catch (e) {
    // saving error
  }
};

export const getBrandId = async () => {
  try {
    let data = await AsyncStorage.getItem('brandId');
    return data != null ? JSON.parse(data) : null;
  } catch (e) {
    // error reading value
  }
};
export const storeOperatorId = async (value) => {
  try {
    await AsyncStorage.setItem('opId', JSON.stringify(value));
  } catch (e) {
    // saving error
  }
};

export const getOperatorId = async () => {
  try {
    let data = await AsyncStorage.getItem('opId');
    return data != null ? JSON.parse(data) : null;
  } catch (e) {
    // error reading value
  }
};
export const storeCartItems = async (value) => {
  try {
    await AsyncStorage.setItem('cart', JSON.stringify(value));
  } catch (e) {
    // saving error
  }
};

export const getCartItems = async () => {
  try {
    let data = await AsyncStorage.getItem('cart');
    return data != null ? JSON.parse(data) : null;
  } catch (e) {
    // error reading value
  }
};

export const clearAll = () => {
  try {
    return AsyncStorage.clear();
  } catch (e) {
    // clear error
  }
};
